import { Stack } from "expo-router";

/**
 * Teams tab stack layout
 * Note: Static routes must be defined BEFORE dynamic routes like [id]
 */
export default function TeamsLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" />
      <Stack.Screen 
        name="customize" 
        options={{ 
          presentation: "modal",
          headerShown: false,
        }} 
      />
      <Stack.Screen 
        name="avatar-creator" 
        options={{ 
          presentation: "fullScreenModal",
          headerShown: false,
          animation: "slide_from_bottom",
        }} 
      />
      {/* Dynamic route must be LAST to avoid matching static routes */}
      <Stack.Screen name="[id]" />
    </Stack>
  );
}
